import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import Routes from './routes';

import './index.css';

// PAGES STYLES
import './styles/globalStyles.scss';
import './styles/pages/LoginPage.scss';
import './styles/pages/OrdersPage.scss';
import './styles/pages/UserPage.scss';

// COMPONENTS STYLES
import './styles/components/SideMenu.scss';
import './styles/components/ToggleButton.scss';
import './styles/components/Table.scss';

// if (window.location.protocol === 'http:' && document.URL.substring(0,16) !== 'http://localhost') {
//     window.location.href =
//         window.location.href.replace(
//                    'http:', 'https:');
// }
const Root = () => (
  <Routes />
)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Root />
);
reportWebVitals();
